import React, { useState } from 'react';
import { Checkbox, FormControlLabel, IconButton, InputAdornment, Typography } from '@mui/material';
import { Grid } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CommonButton from '../../component/button/Button';
import InputComponent from '../../component/input/Input';
import AuthBg from '../../component/auth/AuthBg';
import Heading from '../../component/Heading/Heading';
import { SignUpInputData } from '../../content/content';
import { signUp } from '../../services/authenticationService';
import { useNavigate } from 'react-router';
import Toast from '../../component/toastify/Index';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import logo from "../../assets/icons/logo.svg"
import "../../styles/pages/auth/signUp.scss"
import { useTranslation } from 'react-i18next';

const SignUp = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [isPassword, setIsPassword] = useState(false);
    const [passwordCriteria, setPasswordCriteria] = useState({
        length: false,
        uppercase: false,
        number: false,
        noSpaces: false,
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === 'password') {
            setPasswordCriteria({
                length: value.length >= 8,
                uppercase: /[A-Z]/.test(value),
                number: /[0-9]/.test(value),
                noSpaces: !/\s/.test(value),
            });
            setIsPassword(true);
        }
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShow) => !prevShow);
    };

    const validate = () => {
        let valid = true;
        const newErrors = {};

        SignUpInputData.forEach((item) => {
            if (!formData[item.name]?.trim() && item.name != "password") {
                newErrors[item.name] = `${t(item.translationKey)} ${t("Erforderlich")}`;
                valid = false;
            } else if (item.name === 'email' && !/^\S+@\S+\.\S+$/.test(formData[item.name])) {
                newErrors[item.name] = `${t('Bitte gültige E-Mail-Adresse eingeben')}`;
                valid = false;
            }
            else if (item.name === 'mobileNumber' && formData[item.name].length > 20) {
                newErrors[item.name] = `${t('common_is_valid_mobile_number')}`;
                valid = false;
            }
        });

        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsPassword(true);

        try {
            if (!validate() || !passwordCriteria.length || !passwordCriteria.noSpaces || !passwordCriteria.uppercase || !passwordCriteria.number) return;
            const response = await signUp(formData);
            if (response?.isSuccess) {
                navigate(`/check-your-email/${formData.email}`);
                Toast(response?.message, 'success');
            }
        } catch (error) {
            Toast(error?.message, 'error');
        }
    };

    return (
        <div className="auth sign-up">
            <div className="signup-container">
                <Grid container>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                        <div className="logo-container">
                            <img src={logo} alt="logo" className='company-logo' />
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="signup-data">
                                <div className="input-container">
                                    <Heading text={t("common_label_signup")} />
                                    {SignUpInputData.map((item, index) => (
                                        <div key={index}>
                                            {item.name === 'password' ? (
                                                <>
                                                    <InputComponent
                                                        type={showPassword ? 'text' : 'password'}
                                                        placeholder={t(item.placeholderTranslationKey)}
                                                        label={t(item.translationKey)}
                                                        className="input-field"
                                                        name={item.name}
                                                        value={formData[item.name] || ''}
                                                        onChange={handleChange}
                                                        required
                                                        isAuth
                                                        error={
                                                            !isPassword ? false :
                                                                !passwordCriteria.length ||
                                                                !passwordCriteria.uppercase ||
                                                                !passwordCriteria.number ||
                                                                !passwordCriteria.noSpaces
                                                        } helperText={errors[item.name]}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        className='text-blue'
                                                                        onClick={handleTogglePasswordVisibility}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />

                                                    <Typography className='password-validation' sx={{ display: !isPassword && "none", paddingTop: "10px" }}>
                                                        <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.length ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                            {passwordCriteria.length ? (
                                                                <CheckIcon
                                                                    style={{ color: 'green', marginRight: '8px' }}
                                                                />
                                                            ) : (
                                                                <CloseIcon
                                                                    style={{ color: '#d32f2f', marginRight: '8px' }}
                                                                />
                                                            )}
                                                            {t('common_text_8_characters')}
                                                        </p>
                                                        <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.uppercase ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                            {passwordCriteria.uppercase ? (
                                                                <CheckIcon
                                                                    style={{ color: 'green', marginRight: '8px' }}
                                                                />
                                                            ) : (
                                                                <CloseIcon
                                                                    style={{ color: '#d32f2f', marginRight: '8px' }}
                                                                />
                                                            )}
                                                            {t('common_text_1_uppercase')}
                                                        </p>
                                                        <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.number ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                            {passwordCriteria.number ? (
                                                                <CheckIcon
                                                                    style={{ color: 'green', marginRight: '8px' }}
                                                                />
                                                            ) : (
                                                                <CloseIcon
                                                                    style={{ color: '#d32f2f', marginRight: '8px' }}
                                                                />
                                                            )}
                                                            {t('common_text_1_number')}
                                                        </p>
                                                        <p style={{ display: 'flex', alignItems: 'center', color: passwordCriteria.noSpaces ? "green" : "#d32f2f", fontFamily: "Poppins" }}>
                                                            {passwordCriteria.noSpaces ? (
                                                                <CheckIcon
                                                                    style={{ color: 'green', marginRight: '8px' }}
                                                                />
                                                            ) : (
                                                                <CloseIcon
                                                                    style={{ color: '#d32f2f', marginRight: '8px' }}
                                                                />
                                                            )}
                                                            {t('common_text_no_space')}
                                                        </p>
                                                    </Typography>
                                                </>
                                            ) : (
                                                <InputComponent
                                                    type={item.type}
                                                    placeholder={t(item.placeholderTranslationKey)}
                                                    label={t(item.translationKey)}
                                                    className="input-field"
                                                    name={item.name}
                                                    value={formData[item.name] || ''}
                                                    onChange={handleChange}
                                                    required
                                                    isAuth
                                                    error={!!errors[item.name]}
                                                    helperText={errors[item.name]}
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>

                                <div className="checkbox-container pt-4">
                                    <FormControlLabel
                                        label={t("common_text_keep_me_logged_in")}
                                        control={<Checkbox sx={{ '& .MuiSvgIcon-root': { fill: '#F5D01C', fontSize: 30 } }} />}
                                    />
                                </div>

                                <div className="signup-button">
                                    <CommonButton type="submit" text={t('common_label_signup')} className="submit-button w-100" color='#fff' />
                                </div>
                            </div>
                        </form>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6, lg: 8 }} className="signup-img-padding">
                        <AuthBg />
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default SignUp;
